export default {"src":"/login-app/[GIT_HASH]/_next/static/media/or.e9aaa5a5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};